import { BaseTaskAction } from './_base-task-action';

export class TaskActionUnknown extends BaseTaskAction {
    _unknown: true = true;
}
